<template>
  <OareCard title="Sign In">
    <v-text-field
      v-model="email"
      class="test-email"
      :label="$t('login.email')"
      variant="outlined"
    />
    <v-text-field
      class="test-password"
      @keyup.enter="logIn"
      v-model="password"
      :label="$t('login.password')"
      type="password"
      variant="outlined"
    />
    <p class="subtitle text-error test-error-text">{{ errorMsg }}</p>
    <v-btn class="text-none" to="/send_reset_password_email" variant="text"
      >Forgot your password?</v-btn
    >
    <v-btn class="text-none" to="/register" variant="text">{{
      $t('login.dontHaveAccount')
    }}</v-btn>
    <br />

    <template #actions>
      <OareLoaderButton
        class="text-right test-signin-btn"
        @click="logIn"
        color="primary"
        :loading="loadings.signInButton"
        :disabled="!email || !password"
      >
        {{ $t('login.signIn') }}
      </OareLoaderButton>
    </template>
  </OareCard>
</template>

<script lang="ts">
import { defineComponent, ref, PropType } from 'vue';
import { NavigationGuard, Router } from 'vue-router';
import sl from '@/serviceLocator';
import defaultRouter from '../../../router';
import { INVALID_CREDENTIAL_CODES } from '../authErrors';

const beforeRouteEnter: NavigationGuard = () => {
  const store = sl.get('store');
  return store.getters.isAuthenticated ? '/' : true;
};

export default defineComponent({
  name: 'LoginView',
  props: {
    router: {
      type: Object as PropType<Router>,
      default: () => defaultRouter,
    },
  },
  beforeRouteEnter,
  setup({ router }) {
    const store = sl.get('store');
    const server = sl.get('serverProxy');

    const email = ref('');
    const password = ref('');
    const errorMsg = ref('');
    const loadings = ref({ signInButton: false });

    const logIn = async () => {
      loadings.value.signInButton = true;
      errorMsg.value = '';
      let userData = {
        email: email.value,
        password: password.value,
      };

      try {
        await server.login(userData);
        const permissions = await server.getUserPermissions();
        store.setPermissions(permissions);
        // vue-router's push() is navigation, not an array mutation of the
        // prop, which is what the rule below actually detects.
        // eslint-disable-next-line vue/no-mutating-props
        router.push('/');
      } catch (err) {
        const errorCode = (err as any).code;
        if (INVALID_CREDENTIAL_CODES.includes(errorCode)) {
          errorMsg.value = 'Invalid credentials';
        } else if ((err as any).message) {
          errorMsg.value = (err as any).message;
        } else {
          errorMsg.value = 'There was an unknown error';
        }
      } finally {
        loadings.value.signInButton = false;
      }
    };

    return {
      email,
      password,
      errorMsg,
      loadings,
      logIn,
    };
  },
});
</script>
